/* eslint-disable react/prop-types */
const React = require('react');
const NotFoundIcon = require('./images/NotFound');

const NotFound = ({ i18n, className }) => (
  <article className={`layout__main ${className && className}`}>
    <div className="layout__container">
      <div className="c-404">
        <span className="c-404__img">
          <NotFoundIcon />
        </span>
        <h1 className="c-404__title">
          {i18n.gettext('Lo sentimos, lo que querías ver no existe o lo movimos de lugar.')}
        </h1>
      </div>
    </div>
  </article>
);

module.exports = NotFound;
